import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faCheckCircle,
  faCalendarAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-liquida",
  templateUrl: "./liquida.component.html",
  styleUrls: ["./liquida.component.css"],
})
export class LiquidaComponent implements OnInit {
  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoVal = faCheckCircle;
  icoFec = faCalendarAlt;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  modoLis = 0;
  formLis = 0;
  SwDetal = false;
  SwTotal = false;
  SwExcel = false;
  SwImpre = false;
  SwLista = false;
  resul: boolean;

  prifec: string;
  ultfec: string;

  constructor(
    private srvCentral: CentralService,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }
    this.modoLis = this.srvCentral.EntModoLis;
    this.formLis = this.srvCentral.EntFormLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    switch (this.modoLis) {
      case 0:
        this.SwDetal = true;
        break;
      case 1:
        this.SwTotal = true;
        break;
    }

    switch (this.formLis) {
      case 0:
        this.SwLista = true;
        break;
      case 1:
        this.SwImpre = true;
        break;
      case 2:
        this.SwExcel = true;
        break;
    }
  }

  persiana(): void {
    $("#wrapper").toggleClass("toggled");
  }
  modos(md: number): void {
    this.modoLis = md;
  }
  formas(fm: number): void {
    this.formLis = fm;
  }

  listado(): void {
    const fec1 = this.srvCentral.cadenaFecha(this.prifec);
    const fec2 = this.srvCentral.cadenaFecha(this.ultfec);
    if (fec1 > fec2) {
      const modalRef = this.modalService.open(AvisosComponent);
      modalRef.componentInstance.datAviso = {
        tit: "FECHAS ERRÓNEAS",
        tex: "Fecha inicial posterior a fecha final",
        tip: 1,
        btcan: "",
        btno: "",
        btsi: "Aceptar",
      };
      modalRef.result.then((result) => {});
    } else {
      this.srvCentral.EntModoLis = this.modoLis;
      this.srvCentral.EntFormLis = this.formLis;
      this.srvCentral.gnPriDia = fec1;
      this.srvCentral.gnUltDia = fec2;
      if (this.formLis === 0) {
        this.router.navigate(["/liquidalis"]);
      }
      if (this.formLis === 1) {
        this.router.navigate(["/liquidaimp"]);
      }
      if (this.formLis === 2) {
        this.listadoExcel();
      }
    }
  }

  listadoExcel(): void {
    this.resul = true;
    this.srvCentral
      .consulLiquida(this.modoLis, this.prifec, this.ultfec)
      .subscribe((datos) => {
        if (datos[0].liqFech === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].liqErro,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          this.resul = false;
          const tx = this.srvCentral.saca(datos[0].liqFech);
          const url = this.srvCentral.UrlCave + "/" + tx;
          window.open(url, "_blank");
        }
      });
  }
}
